import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
  FormField,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import React from 'react';
import { FieldPathByValue, FieldValues } from 'react-hook-form';

import { FieldOptions, FieldProps } from './shared';

export function SelectField<
  T extends FieldValues,
  P extends FieldPathByValue<T, string>,
>({
  control,
  name,
  rules,
  label,
  placeholder,
  description,
  options,
  ...props
}: FieldProps<T, P> &
  React.ComponentPropsWithoutRef<typeof SelectTrigger> & {
    className?: string;
    placeholder?: string;
  } & FieldOptions) {
  return (
    <FormField
      control={control}
      name={name}
      rules={rules}
      render={({ field: { value, onChange, ...field } }) => (
        <FormItem className="grow">
          <FormLabel>{label}</FormLabel>
          <Select value={String(value ?? '')} onValueChange={onChange}>
            <FormControl>
              <SelectTrigger {...props} {...field}>
                <SelectValue placeholder={placeholder ?? `Select ${label}`} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {options.map((option) => (
                <SelectItem key={option.id} value={option.id}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormDescription>{description?.(value)}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
